import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const useDlyGrafStore = create(
  persist(
    set => ({
      isAktual: false,
      activeTab: 'graf',
      chartFormat: 'png',
      interactive: false,

      setIsAktual: isAktual => set({ isAktual }),
      setActiveTab: activeTab => set({ activeTab }),
      setChartFormat: chartFormat => set({ chartFormat }),
      setInteractive: interactive => set({ interactive }),
    }),
    {
      name: 'dly-graf-store',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
